import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import { HandCoins, Prohibit } from '@phosphor-icons/react';

const ManagerSalesTab = ({ children, darkMode }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isRestaurantType = ['FOOD_AND_BEVERAGE', 'RESTAURANT'].includes(user?.businessType);

  const tabs = [
    { key: 'revenue', label: 'Revenue', icon: HandCoins, path: `/${slug}/manager/sales` },
    { key: 'requests', label: isRestaurantType ? 'Cancel Orders' : 'Void Requests', icon: Prohibit, path: `/${slug}/manager/sales/requests` },
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default ManagerSalesTab;
